import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

import VtrgCenteredImage from "../../piece_components/vtrg_centered_image/vtrg_centered_image";
import VtrgCenteredImageForm from "../../piece_components/vtrg_centered_image/vtrg_centered_image_form";
import VtrgCustomBlock from "../../piece_components/vtrg_custom_block/vtrg_custom_block";
import VtrgCustomBlockForm from "../../piece_components/vtrg_custom_block/vtrg_custom_block_form";
import VtrgCustomHtml from "../../piece_components/vtrg_custom_html/vtrg_custom_html";
import VtrgCustomHtmlForm from "../../piece_components/vtrg_custom_html/vtrg_custom_html_form";
import VtrgInnerBlock from "../../piece_components/vtrg_inner_block/vtrg_inner_block";
import VtrgInnerBlockForm from "../../piece_components/vtrg_inner_block/vtrg_inner_block_form";
import VtrgJsonImg from "../../piece_components/vtrg_json_img/vtrg_json_img";
import VtrgJsonImgForm from "../../piece_components/vtrg_json_img/vtrg_json_img_form";
import VtrgSplitScreen from "../../piece_components/vtrg_split_screen/vtrg_split_screen";
import VtrgSplitScreenForm from "../../piece_components/vtrg_split_screen/vtrg_split_screen_form";
import VtrgText from "../../piece_components/vtrg_text/vtrg_text";
import VtrgTextForm from "../../piece_components/vtrg_text/vtrg_text_form";
import VtrgThreeColumns from "../../piece_components/vtrg_three_columns/vtrg_three_columns";
import VtrgThreeColumnsForm from "../../piece_components/vtrg_three_columns/vtrg_three_columns_form";
import VtrgVideo from "../../piece_components/vtrg_video/vtrg_video";
import VtrgVideoForm from "../../piece_components/vtrg_video/vtrg_video_form";
import VtrgWasBecameImage from "../../piece_components/vtrg_was_became_image/vtrg_was_became_image";
import VtrgWasBecameImageForm from "../../piece_components/vtrg_was_became_image/vtrg_was_became_image_form";
import { request } from "../../../api";

import VtrgPanel from "./VtrgPanel";
import HoverPanel from "./HoverPanel";
import VtrgEditPanel from "./VtrgEditPanel";
import ReorderPopup from "./ReorderPopup";

const BOTTOM_ADD_PANEL = "bottom";

const byOrdn = (a, b) => (a.ordn > b.ordn ? 1 : -1);

// changed - массив [{ slot, ordn }], который возвращает сервер после reorder
const applyOrder = (items, changed) =>
  items.map((item) => {
    const changedItem = changed.find((o) => o.slot === item.slot);
    return changedItem ? { ...item, ordn: changedItem.ordn } : item;
  });

// TODO исправить это: params и вложенные поля нового блока приходят строками JSON
const normalizeNewPiece = (data) => {
  const new_data = { ...data };
  new_data.params =
    typeof data.params === "string" ? JSON.parse(data.params) : data.params;
  const inner = new_data.params && new_data.params.inner;

  if (inner && inner[1]) {
    [0, 1].forEach((i) => {
      if (typeof inner[i].video === "string")
        inner[i].video = JSON.parse(inner[i].video);
      if (typeof inner[i].image === "string")
        inner[i].image = JSON.parse(inner[i].image);
    });
  } else if (inner) {
    if (typeof inner.video === "string") inner.video = JSON.parse(inner.video);
    if (typeof inner.image === "string") inner.image = JSON.parse(inner.image);
  }

  return new_data;
};

const EditVtrgContent = ({
  content,
  instanceTypeEl = "",
  instanceIdEl = "",
}) => {
  const [retweetWindowShow, setRetweetWindowShow] = useState(false);
  const [updateblePiece, updatePiece] = useState(false);
  const [hideUpdatePanel, setHideUpdatePanel] = useState(null);
  const [someActionLoading, setActionLoading] = useState(null);
  const [localContent, setLocalContent] = useState(content ? content : []);
  // Какая панель добавления блока открыта: слот блока, после которого стоит HoverPanel,
  // или BOTTOM_ADD_PANEL для нижней. Одновременно может быть открыта только одна
  const [activeAddPanel, setActiveAddPanel] = useState(null);

  // Контент приходит асинхронно (useAxios), поэтому подхватываем его, когда он появится
  useEffect(() => {
    if (content && content.length > 0) {
      setLocalContent(content);
    }
  }, [content]);

  // Актуальный список блоков для колбэков, которые могли замкнуть старый стейт
  const contentRef = useRef(localContent);
  contentRef.current = localContent;

  const ownerType =
    content && content[0] && content[0].parent_type
      ? content[0].parent_type
      : instanceTypeEl;
  const ownerId =
    content && content[0] && content[0].parent_id
      ? content[0].parent_id
      : instanceIdEl;

  const refreshResults = (id, arr) => {
    setLocalContent((prev) => applyOrder(prev, arr));
  };

  const setNewOrderRetweet = (
    slotCurrentElement,
    slotPrevElement,
    oldOrdnCurrentElement,
  ) => {
    // slotCurrentElement - Слот текущего,перетаскиваемого, элемента
    // slotPrevElement - Слот элемента на место которого встаёт Текущий слот (slot или "end", если элемент послдений)
    // oldOrdnCurrentElement - oldOrdnCurrentElement текущего слота, до переноса

    setHideUpdatePanel(oldOrdnCurrentElement);
    setActionLoading(oldOrdnCurrentElement);

    const dataForm = new FormData();

    dataForm.set("id", slotCurrentElement);
    dataForm.set("beforeid", slotPrevElement);

    axios
      .post(`${request}/vitrage/pieces/${slotCurrentElement}/reorder`, dataForm)
      .then((response) => {
        if (response.statusText === "OK") {
          console.log("block is reordering");
          refreshResults(
            response?.data?.data?.id,
            JSON.parse(response?.data?.data?.changed),
          );
        } else {
          console.log(response.statusText);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setActionLoading(null);
        setHideUpdatePanel(null);
      });
  };

  // afterSlot - слот блока, после которого нужно вставить новый.
  // Если не передан (нижняя панель), блок остаётся в конце, как его создал сервер.
  // Возвращает промис перестановки (или undefined, если она не нужна) —
  // форма, создающая несколько блоков подряд, ждёт его перед созданием следующего
  const afterCreateVtrgPiece = (data, afterSlot) => {
    if (!data) {
      console.log("error");
      return;
    }

    const newPiece = normalizeNewPiece(data);
    const serverOrdn = newPiece.ordn;

    const sorted = [...contentRef.current]
      .filter((item) => item.slot !== newPiece.slot)
      .sort(byOrdn);
    const afterIndex =
      afterSlot !== undefined && afterSlot !== null
        ? sorted.findIndex((item) => item.slot === afterSlot)
        : -1;
    const nextItem = afterIndex >= 0 ? sorted[afterIndex + 1] : null;

    if (nextItem) {
      // Сразу показываем блок на нужном месте (между afterSlot и следующим),
      // настоящие ordn придут от сервера после reorder
      newPiece.ordn = (sorted[afterIndex].ordn + nextItem.ordn) / 2;
    }

    setLocalContent((prev) => [
      ...prev.filter((item) => item.slot !== newPiece.slot),
      newPiece,
    ]);

    if (!nextItem) return;

    const dataForm = new FormData();
    dataForm.set("id", newPiece.slot);
    dataForm.set("beforeid", nextItem.slot);

    setActionLoading(newPiece.ordn);

    return axios
      .post(`${request}/vitrage/pieces/${newPiece.slot}/reorder`, dataForm)
      .then((response) => {
        const changed = JSON.parse(response?.data?.data?.changed || "[]");
        setLocalContent((prev) => applyOrder(prev, changed));
      })
      .catch((error) => {
        console.log(error);
        // Не удалось переставить: на сервере блок остался в конце, показываем так же
        setLocalContent((prev) =>
          prev.map((item) =>
            item.slot === newPiece.slot ? { ...item, ordn: serverOrdn } : item,
          ),
        );
      })
      .finally(() => {
        setActionLoading(null);
      });
  };

  const checkComponent = (
    ordn,
    role,
    block_params,
    instance_type,
    instance_id,
    slot,
    isLastElement,
  ) => {
    const components = {
      vtrg_centered_image:
        updateblePiece === ordn ? VtrgCenteredImageForm : VtrgCenteredImage,
      vtrg_custom_block:
        updateblePiece === ordn ? VtrgCustomBlockForm : VtrgCustomBlock,
      vtrg_custom_html:
        updateblePiece === ordn ? VtrgCustomHtmlForm : VtrgCustomHtml,
      vtrg_inner_block:
        updateblePiece === ordn ? VtrgInnerBlockForm : VtrgInnerBlock, // ?
      vtrg_json_img: updateblePiece === ordn ? VtrgJsonImgForm : VtrgJsonImg,
      vtrg_split_screen:
        updateblePiece === ordn ? VtrgSplitScreenForm : VtrgSplitScreen,
      vtrg_text: updateblePiece === ordn ? VtrgTextForm : VtrgText,
      vtrg_three_columns:
        updateblePiece === ordn ? VtrgThreeColumnsForm : VtrgThreeColumns,
      vtrg_video: updateblePiece === ordn ? VtrgVideoForm : VtrgVideo,
      vtrg_was_became_image:
        updateblePiece === ordn ? VtrgWasBecameImageForm : VtrgWasBecameImage,
    };

    const Component = components[role];

    const RetweetVtrgPiece = () => {
      setHideUpdatePanel(ordn);
      // открывать модальное окно
      setRetweetWindowShow(true);
      //  убрать здесь
    };

    const UpdateVtrgPiece = (ordn) => {
      setHideUpdatePanel(ordn);
      updatePiece(ordn);
    };
    // TODO и снова косытль
    const afterUpdateVtrgPiece = (data) => {
      if (data) {
        if (data.params) {
          data = JSON.parse(data.params);
        }
        Object.keys(block_params)
          .filter((key) => key in data)
          .forEach((key) => (block_params[key] = data[key]));
      }
      // Вызывается и без data при отмене редактирования — панель нужно вернуть в любом случае
      setHideUpdatePanel(null);
    };
    const DestroyVtrgPiece = () => {
      setHideUpdatePanel(ordn);
      setActionLoading(ordn);
      axios
        .delete(`${request}/vitrage/pieces/${slot}`, { data: slot })
        .then((response) => {
          if (response.statusText === "OK") {
            console.log("Блок успешно удален!");

            setLocalContent((prev) => prev.filter((o) => o.slot !== slot));
          } else {
            console.log(response.statusText);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setActionLoading(null);
          setHideUpdatePanel(null);
        });
    };

    return (
      <div
        key={slot}
        className={`vtrg-edit-wrapper ${
          someActionLoading === ordn ? "is--loading" : ""
        }`}
      >
        <VtrgEditPanel
          hideUpdatePanel={hideUpdatePanel}
          ordn={ordn}
          RetweetVtrgPiece={RetweetVtrgPiece}
          DestroyVtrgPiece={DestroyVtrgPiece}
          UpdateVtrgPiece={UpdateVtrgPiece}
          position="top"
        />

        <Component
          key={block_params.id}
          data={block_params}
          instanceType={instance_type}
          instanceId={instance_id}
          pieceType={role}
          slot={slot}
          updatePiece={updatePiece}
          setActionLoading={setActionLoading}
          ordn={ordn}
          afterUpdateVtrgPiece={afterUpdateVtrgPiece}
        />

        <VtrgEditPanel
          hideUpdatePanel={hideUpdatePanel}
          ordn={ordn}
          RetweetVtrgPiece={RetweetVtrgPiece}
          DestroyVtrgPiece={DestroyVtrgPiece}
          UpdateVtrgPiece={UpdateVtrgPiece}
          position="bottom"
        />

        {someActionLoading === ordn && <span className="show-spiner"></span>}

        {!isLastElement && (
          <HoverPanel
            instanceType={ownerType}
            instanceId={ownerId}
            afterSlot={slot}
            isActive={activeAddPanel === slot}
            onActivate={() => setActiveAddPanel(slot)}
            updatePiece={updatePiece}
            setActionLoading={setActionLoading}
            afterUpdateVtrgPiece={afterCreateVtrgPiece}
          />
        )}
      </div>
    );
  };

  const sortedContent = [...localContent].sort(byOrdn);

  const result = sortedContent.map((item, index, arr) =>
    checkComponent(
      item.ordn,
      item.type,
      item.params,
      item.parent_type,
      item.parent_id,
      item.slot,
      arr.length - 1 === index,
    ),
  );

  return (
    <div className="vtrg-main-container">
      {result}

      <VtrgPanel
        instanceType={ownerType}
        instanceId={ownerId}
        updatePiece={updatePiece}
        setActionLoading={setActionLoading}
        afterUpdateVtrgPiece={afterCreateVtrgPiece}
        isActive={activeAddPanel === BOTTOM_ADD_PANEL}
        onFormChange={(isOpen) => {
          if (isOpen) {
            setActiveAddPanel(BOTTOM_ADD_PANEL);
          }
        }}
      />

      {retweetWindowShow ? (
        <ReorderPopup
          content={sortedContent}
          setRetweetWindowShow={setRetweetWindowShow}
          setHideUpdatePanel={setHideUpdatePanel}
          setNewOrderRetweet={setNewOrderRetweet}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default EditVtrgContent;
